var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "table",
    { staticClass: "h-table account-history" },
    [
      _c("thead", [
        _c(
          "tr",
          _vm._l(_vm.columns, function (column) {
            return _c(
              "th",
              { key: column.id, staticClass: "h-table__col-title" },
              [_vm._v(" " + _vm._s(column.fullName) + " ")]
            )
          }),
          0
        ),
      ]),
      _c("transition", { attrs: { name: "slide" } }, [
        _c(
          "tbody",
          { staticClass: "slide-transition" },
          [
            _vm.operations
              ? _c(
                  "tr",
                  {
                    staticClass: "h-table__row h-table__header-row",
                    staticStyle: { "text-align": "right" },
                  },
                  [
                    _c("td"),
                    _c("td"),
                    _c("td", { staticClass: "positive-number" }, [
                      _vm._v(_vm._s(this.totalDeposit.toFixed(2))),
                    ]),
                    _c("td", { staticClass: "negative-number" }, [
                      _vm._v(_vm._s(this.totalWithdraw.toFixed(2))),
                    ]),
                    _c("td"),
                    _c("td"),
                  ]
                )
              : _vm._e(),
            _vm._l(_vm.operations, function (operation) {
              return _c(
                "tr",
                { key: operation.id.value, staticClass: "h-table__row" },
                _vm._l(_vm.columns, function (column) {
                  return _c("cell", {
                    key: column.id,
                    attrs: { column: column, operation: operation },
                  })
                }),
                1
              )
            }),
          ],
          2
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }